import { render, staticRenderFns } from "./SpecialQuestionDetail.vue?vue&type=template&id=c41798f4&scoped=true"
import script from "./SpecialQuestionDetail.vue?vue&type=script&lang=js"
export * from "./SpecialQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialQuestionDetail.vue?vue&type=style&index=0&id=c41798f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41798f4",
  null
  
)

export default component.exports